import React from "react";
import { useNavigate } from "react-router-dom";
import { X, Plus, Minus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const CartDrawer = () => {
  const { items, isOpen, setIsOpen, removeItem, updateQty, total, count } =
    useCart();
  const navigate = useNavigate();

  const checkout = () => {
    setIsOpen(false);
    navigate("/checkout");
  };

  return (
    <>
      <div
        onClick={() => setIsOpen(false)}
        className={`fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      />
      <aside
        className={`fixed top-0 right-0 z-[70] h-full w-full max-w-md bg-navy-800 border-l border-gold/20 shadow-2xl transition-transform duration-400 flex flex-col ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-6 h-20 border-b border-white/10">
          <h3 className="text-white font-display font-bold text-xl flex items-center gap-2">
            <ShoppingBag size={20} className="text-gold" /> Your Cart ({count})
          </h3>
          <button
            onClick={() => setIsOpen(false)}
            className="h-9 w-9 rounded-lg border border-gold/30 text-white flex items-center justify-center hover:bg-navy-700 transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-4">
          {items.length === 0 && (
            <div className="text-center text-slate-400 mt-20">
              <ShoppingBag size={40} className="mx-auto text-navy-600 mb-4" />
              <p>Your cart is empty.</p>
            </div>
          )}
          {items.map((i) => (
            <div
              key={i.key}
              className="flex gap-4 bg-navy-700 rounded-xl p-3 gold-border"
            >
              <img
                src={i.image}
                alt={i.name}
                className="h-20 w-20 rounded-lg object-cover"
              />
              <div className="flex-1 min-w-0">
                <p className="text-white font-semibold text-sm truncate">
                  {i.name}
                </p>
                <p className="text-slate-400 text-xs mb-2">{i.option}</p>
                <div className="flex items-center gap-3">
                  <div className="flex items-center border border-gold/30 rounded-lg">
                    <button
                      onClick={() => updateQty(i.key, -1)}
                      className="h-7 w-7 flex items-center justify-center text-white hover:text-gold"
                    >
                      <Minus size={13} />
                    </button>
                    <span className="w-7 text-center text-white text-sm">
                      {i.qty}
                    </span>
                    <button
                      onClick={() => updateQty(i.key, 1)}
                      className="h-7 w-7 flex items-center justify-center text-white hover:text-gold"
                    >
                      <Plus size={13} />
                    </button>
                  </div>
                  <span className="text-gold font-semibold text-sm ml-auto">
                    ${(i.price * i.qty).toFixed(2)}
                  </span>
                  <button
                    onClick={() => removeItem(i.key)}
                    className="text-slate-500 hover:text-red-400 transition-colors"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-white/10 px-6 py-5">
            <div className="flex items-center justify-between mb-4">
              <span className="text-slate-300">Subtotal</span>
              <span className="text-white font-display font-bold text-2xl">
                ${total.toFixed(2)}
              </span>
            </div>
            <button
              onClick={checkout}
              className="w-full bg-gold hover:bg-gold-light text-navy font-semibold py-3.5 rounded-xl transition-colors duration-200"
            >
              Proceed to Checkout
            </button>
          </div>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
